<script setup>

defineProps({
  filtros: { type: Object, required: true },
  gruposDisponiveis: { type: Array, default: () => [] },
  temFiltroAtivo: { type: Boolean, default: false }
})

const emit = defineEmits([
  'aplicar-filtros',
  'limpar-filtros',
  'alternar-grupo',
  'update:buscaResumo'
])
</script>

<template>
  <div class="filtro-inline-row">
    <!-- Filtro: Resumo -->
    <div class="filtro-group filtro-resumo">
      <label class="form-label filtro-label">Resumo</label>
      <input
        type="text"
        class="form-control form-control-sm"
        :value="filtros.buscaResumo"
        @input="emit('update:buscaResumo', $event.target.value)"
        placeholder="Filtrar por resumo..."
        @keydown.enter.prevent="emit('aplicar-filtros')"
      >
    </div>

    <!-- Filtro: Grupo Aprovador (badges) -->
    <div class="filtro-group filtro-grupo" v-if="gruposDisponiveis.length > 0">
      <label class="form-label filtro-label">Grupo</label>
      <div class="d-flex flex-wrap gap-1">
        <button
          v-for="grupo in gruposDisponiveis"
          :key="grupo.id"
          class="badge rounded-pill px-3 py-2 text-decoration-none border-0"
          :class="filtros.idGrupoAprovador === grupo.id ? 'text-bg-info' : 'text-bg-light text-body-secondary border'"
          @click="emit('alternar-grupo', grupo.id)"
        >
          {{ grupo.nome }}
        </button>
      </div>
    </div>

    <!-- Botões de ação -->
    <div class="filtro-group filtro-acoes">
      <div class="d-flex gap-1">
        <button
          class="btn btn-sm btn-outline-secondary"
          @click="emit('limpar-filtros')"
          :disabled="!temFiltroAtivo"
          title="Limpar filtros"
        >
          <i class="bi bi-x-lg"></i>
        </button>
        <button class="btn btn-sm btn-primary" @click="emit('aplicar-filtros')">
          <i class="bi bi-search"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* === Filtros inline - mobile-first === */
.filtro-inline-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: flex-end;
}

.filtro-group {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.filtro-label {
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--bs-secondary-color);
  margin-bottom: 0;
}

.filtro-resumo {
  flex: 1 1 160px;
  min-width: 130px;
}

.filtro-grupo {
  flex: 1 1 100%;
}

.filtro-acoes {
  flex: 0 0 auto;
}

/* Badges de grupo clicáveis */
.filtro-grupo .badge {
  cursor: pointer;
  font-size: 0.75rem;
  font-weight: 500;
  transition: all 0.15s ease;
  white-space: nowrap;
}

/* Badge não selecionada: fundo semi-transparente com borda para garantir contraste em dark/light */
.filtro-grupo .badge.text-bg-light {
  background-color: color-mix(in srgb, var(--bs-secondary-bg) 60%, transparent) !important;
  color: var(--bs-body-color) !important;
  border-color: var(--bs-border-color) !important;
}

.filtro-grupo .badge:hover {
  opacity: 0.85;
  transform: translateY(-1px);
}

/* Ajustes responsivos */
@media (max-width: 576px) {
  .filtro-inline-row {
    gap: 0.4rem;
  }

  .filtro-resumo {
    flex: 1 1 100%;
    min-width: 0;
  }

  .filtro-grupo .badge {
    font-size: 0.7rem;
    padding: 0.25rem 0.6rem;
  }

  .filtro-acoes {
    flex: 1 1 100%;
  }

  .filtro-acoes .d-flex {
    justify-content: flex-end;
  }
}
</style>
